import { useIsSubUser } from "melco-shared-logic";

export const useIsAllowedToUpdateEMailAddress = () => {
  const isSubUser = useIsSubUser();

  // only master users can update the account's email address
  return !isSubUser;
};
